import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import moment from "moment";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import PretendardText from "../../../component/atoms/text/pretendardText";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import MainInput from "./../../../component/atoms/input/mainInput";
import Checkbox from "./../../../component/atoms/input/checkbox";
import Radio from "./../../../component/atoms/input/radio";
import DateInput from "./../../../component/atoms/input/dateInput";
import SearchBar from "./../../../component/atoms/input/searchBar";
import GrayBtn from "./../../../component/atoms/button/grayBtn";
import RedBtn from "../../../component/atoms/button/redBtn";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import TableCount from "./../../../component/molecules/tableCount";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import Pagination from "./../../../component/molecules/pagination";
import Td from "./../../../component/atoms/layout/table/td";
import TableText from "./../../../component/atoms/text/table/tableText";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import SelectBoxV2 from "../../../component/organisms/selectBoxValue";
import { toastMsg } from "../../../util/toastMsg";
import scrollToTop from "../../../util/scrollToTop";
import { errorHandler } from "../../../util/errorHandler";
import { route } from "../../../router/route";
import PointApi from "../../../api/point.api";
import Empty from "../../../component/molecules/empty";
import RelatedProductsPopup from "../../../component/templates/modal/relatedProductsPopup";
import CategoryApi from "../../../api/category.api";

// TODO: 게시물 좋아요 받는 수마다에 제한 없는 경우 무한 버그 있어서 주석해둠

// sessionStorage 초기화
function sessionStorageInit() {
  sessionStorage.removeItem("sCheckedListStorage");
  const event = new Event("sessionStorageChange");
  window.dispatchEvent(event);
}

const OperationPoint = () => {
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.operation_point)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [pointSetting, setPointSetting] = useState({});
  const [likeIsUnlimited, setLikeIsUnlimited] = useState(false);
  const [reviewIsUnlimited, setReviewIsUnlimited] = useState(false);

  const [pointEvent, setPointEvent] = useState({});
  const [rangeListBoxOpen, setRangeListBoxOpen] = useState(false);
  const rangeList = [
    {
      title: "모든상품",
      value: "ALL",
    },
    {
      title: "지정 카테고리",
      value: "CATEGORY",
    },
    {
      title: "지정 상품",
      value: "MERCH",
    },
  ];
  const [selectedRange, setSelectedRange] = useState("");

  const [categoryListBoxOpen, setCategoryListBoxOpen] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [merchIdList, setMerchIdList] = useState([]);

  const [noPeriodLimit, setNoPeriodLimit] = useState(false);

  // 게시글 좋아요 받는 수마다 1일 n회 한도 무제한 참일 경우 1일 n회 한도 초기화
  useEffect(() => {
    if (likeIsUnlimited) {
      setPointSetting({
        ...pointSetting,
        likeLimit: 0,
      });
    }
  }, [likeIsUnlimited]); // eslint-disable-line react-hooks/exhaustive-deps

  // 후기 1회 작성 1일 n회 한도 무제한 참일 경우 1일 n회 한도 초기화
  useEffect(() => {
    if (reviewIsUnlimited) {
      setPointSetting({
        ...pointSetting,
        reviewLimit: 0,
      });
    }
  }, [reviewIsUnlimited]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getPointSettingInfoFunc();
    getPointEventInfoFunc();
    getPointHistoryListFunc();

    return () => {
      sessionStorage.removeItem("sCheckedListStorage");
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // 포인트 설정 정보 가져오기
  const getPointSettingInfoFunc = async () => {
    try {
      const response = (await PointApi.getSettingInfo()).data.data.content;

      if (response.likeLimit === 0) {
        setLikeIsUnlimited(true);
      }

      if (response.reviewLimit === 0) {
        setReviewIsUnlimited(true);
      }

      setPointSetting(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  const editPointSettingFunc = async () => {
    try {
      await PointApi.editSetting(pointSetting);
      getPointSettingInfoFunc();
      toast(toastMsg.create);
      scrollToTop();
    } catch (error) {
      errorHandler(error);
    }
  };

  // 포인트 지급이벤트 정보 가져오기
  const getPointEventInfoFunc = async () => {
    try {
      const response = (await PointApi.getEventInfo()).data.data.content;

      setPointEvent(response);
      setSelectedRange(response.pointEventRange);

      if (response.startDate == null || response.endDate == null) {
        setNoPeriodLimit(true);
      }

      getMainCategoryList();
    } catch (error) {
      errorHandler(error);
    }
  };

  //  상품 카테고리 가져오기
  const getMainCategoryList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        sort: "orderNumber",
        orderBy: "ASC",
      };
      const response = (await CategoryApi.getListMain(data)).data.data.content;

      let temp = response.map((item) => {
        return {
          value: item.id,
          title: item.title,
        };
      });

      setCategoryList(temp);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (
      categoryList &&
      categoryList.length > 0 &&
      pointEvent.categoryId !== 0
    ) {
      // KYY 추후에 서버 데이터 연동 적용 필요
      if (
        pointEvent.merchMainCategoryList &&
        pointEvent.merchMainCategoryList.length > 0
      ) {
        setSelectedCategory(pointEvent.merchMainCategoryList[0].id);
      } else {
        setMerchIdList(pointEvent.merchList);
      }
    }
  }, [categoryList, pointEvent]); // eslint-disable-line react-hooks/exhaustive-deps

  const [popupOpen, setPopupOpen] = useState(false);

  useEffect(() => {
    if (selectedRange !== "CATEGORY") {
      setSelectedCategory();
    }
  }, [selectedRange]); // eslint-disable-line react-hooks/exhaustive-deps

  // 포인트 설정 정보 저장하기
  const editPointEventFunc = async () => {
    try {
      let merchIdListTemp = merchIdList.map((item) => item.id);

      if (!noPeriodLimit) {
        if (!pointEvent.endDate) {
          toast("종료날짜를 선택해주세요.");
          return;
        }
      }

      const data = {
        activation: pointEvent.activation,
        ratio: pointEvent.ratio,
        pointEventRange: selectedRange,
        startDate: noPeriodLimit
          ? null
          : moment(pointEvent.startDate).format("YYYY-MM-DD"),
        endDate: noPeriodLimit
          ? null
          : moment(pointEvent.endDate).format("YYYY-MM-DD"),
      };

      switch (selectedRange) {
        case "ALL":
          data.allFlag = true;
          data.merchCategoryIdList = [];
          data.merchIdList = [];
          break;

        case "CATEGORY":
          if (!selectedCategory) {
            return toast("카테고리를 선택해주세요.");
          }

          data.allFlag = false;
          data.merchCategoryIdList = [selectedCategory];
          data.merchIdList = [];
          break;

        case "MERCH":
          if (merchIdListTemp.length === 0) {
            return toast("상품을 선택해주세요.");
          }

          data.allFlag = false;
          data.merchCategoryIdList = [];
          data.merchIdList = merchIdListTemp;
          break;

        default:
          break;
      }

      await PointApi.editEvent(data);
      getPointEventInfoFunc();
      toast(toastMsg.create);
      scrollToTop();
    } catch (error) {
      errorHandler(error);
    }
  };

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

  const [keyword, setKeyword] = useState("");

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  // ---------- 테이블 관련 --------- //
  const [pointList, setPointList] = useState([]);

  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");

    getPointHistoryListFunc();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  // 포인트 지급 내역 가져오기
  const getPointHistoryListFunc = async () => {
    try {
      const data = {
        page: Number(page),
        size: Number(pagination.size),
      };

      if (keyword) {
        data.keyword = searchParams.get("keyword");
      }

      const response = (await PointApi.getPointHistoryList(data)).data.data;

      const processedResponse = [...response.content].map((item, index) => {
        return {
          ...item,
          checked: false,
        };
      });

      setPointList(processedResponse);
      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / 10),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const sessionStorageCheckedList = sessionStorage.getItem(
    "sCheckedListStorage"
  );
  const [checkedListStorage, setCheckedListStorage] = useState([]);
  const [isAllCheck, setIsAllCheck] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setCheckedListStorage(
        sessionStorageCheckedList ? JSON.parse(sessionStorageCheckedList) : []
      );
    };

    window.addEventListener("sessionStorageChange", handleStorageChange);

    return () => {
      window.removeEventListener("sessionStorageChange", handleStorageChange);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    sessionStorage.setItem(
      "sCheckedListStorage",
      JSON.stringify(checkedListStorage)
    );
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (pointList.length > 0) {
      const idsInArray1 = new Set(checkedListStorage.map((item) => item.id));

      const allIdsIncluded = pointList.every((item) =>
        idsInArray1.has(item.id)
      );

      setIsAllCheck(allIdsIncluded);
    }
  }, [checkedListStorage, pointList]); // es

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle
            style={{
              marginBottom: 40,
            }}
          >
            포인트 관리
          </TableTitle>

          {/* ********** 포인트 지급 설정 ********** */}
          <PointSubTitle>포인트 지급 설정</PointSubTitle>
          <SettingContainer>
            {/* 신규 회원가입 시 */}
            <PointItemWrapper>
              <PointItemTitle>신규 회원가입 시</PointItemTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <MainInput
                    type={"text"}
                    placeholder={"0"}
                    style={{
                      width: "93px",
                      textAlign: "right",
                    }}
                    value={pointSetting.joinPoint}
                    onChange={(e) => {
                      setPointSetting({
                        ...pointSetting,
                        joinPoint: e.target.value,
                      });
                    }}
                  />
                  <PointItemContentText>포인트</PointItemContentText>
                </div>
                <PretendardText
                  style={{
                    fontWeight: 500,
                    fontSize: "13px",
                    lineHeight: "18.75px",
                    color: "rgba(181, 181, 181, 0.5)",
                    marginTop: "12px",
                  }}
                >
                  신규 가입시 첫 1회만 지급
                </PretendardText>
              </div>
            </PointItemWrapper>

            {/* 1회 로그인마다 */}
            <PointItemWrapper>
              <PointItemTitle>1회 로그인마다</PointItemTitle>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <MainInput
                  type={"text"}
                  placeholder={"0"}
                  style={{
                    width: "93px",
                    textAlign: "right",
                  }}
                  value={pointSetting.loginPoint}
                  onChange={(e) => {
                    setPointSetting({
                      ...pointSetting,
                      loginPoint: e.target.value,
                    });
                  }}
                />
                <PointItemContentText>포인트</PointItemContentText>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  marginLeft: 40,
                }}
              >
                <PointItemContentText>1일</PointItemContentText>
                <MainInput
                  type={"text"}
                  placeholder={"0"}
                  style={{
                    width: "93px",
                    textAlign: "right",
                  }}
                  value={pointSetting.loginLimit}
                  onChange={(e) => {
                    setPointSetting({
                      ...pointSetting,
                      loginLimit: e.target.value,
                    });
                  }}
                />
                <PointItemContentText>회 한도</PointItemContentText>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  marginLeft: 40,
                }}
              >
                <PointItemContentText>하루 최대 지급 한도</PointItemContentText>
                <MainInput
                  type={"text"}
                  placeholder={"0"}
                  style={{
                    width: "93px",
                    textAlign: "right",
                  }}
                  value={pointSetting.loginPoint * pointSetting.loginLimit}
                  disabled={true}
                  onChange={() => {}}
                />
                <PointItemContentText>포인트</PointItemContentText>
              </div>
            </PointItemWrapper>

            {/* 댓글 1회 작성 */}
            <PointItemWrapper>
              <PointItemTitle>댓글 1회 작성</PointItemTitle>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <MainInput
                  type={"text"}
                  placeholder={"0"}
                  style={{
                    width: "93px",
                    textAlign: "right",
                  }}
                  value={pointSetting.commentPoint}
                  onChange={(e) => {
                    setPointSetting({
                      ...pointSetting,
                      commentPoint: e.target.value,
                    });
                  }}
                />
                <PointItemContentText>포인트</PointItemContentText>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  marginLeft: 40,
                }}
              >
                <PointItemContentText>1일</PointItemContentText>
                <MainInput
                  type={"text"}
                  placeholder={"0"}
                  style={{
                    width: "93px",
                    textAlign: "right",
                  }}
                  value={pointSetting.commentLimit}
                  onChange={(e) => {
                    setPointSetting({
                      ...pointSetting,
                      commentLimit: e.target.value,
                    });
                  }}
                />
                <PointItemContentText>회 한도</PointItemContentText>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  marginLeft: 40,
                }}
              >
                <PointItemContentText>하루 최대 지급 한도</PointItemContentText>
                <MainInput
                  type={"text"}
                  placeholder={"0"}
                  style={{
                    width: "93px",
                    textAlign: "right",
                  }}
                  value={pointSetting.commentPoint * pointSetting.commentLimit}
                  disabled={true}
                  onChange={() => {}}
                />
                <PointItemContentText>포인트</PointItemContentText>
              </div>
            </PointItemWrapper>

            {/* 게시글 1회 작성 */}
            <PointItemWrapper>
              <PointItemTitle>게시글 1회 작성</PointItemTitle>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <MainInput
                  type={"text"}
                  placeholder={"0"}
                  style={{
                    width: "93px",
                    textAlign: "right",
                  }}
                  value={pointSetting.writePoint}
                  onChange={(e) => {
                    setPointSetting({
                      ...pointSetting,
                      writePoint: e.target.value,
                    });
                  }}
                />
                <PointItemContentText>포인트</PointItemContentText>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  marginLeft: 40,
                }}
              >
                <PointItemContentText>1일</PointItemContentText>
                <MainInput
                  type={"text"}
                  placeholder={"0"}
                  style={{
                    width: "93px",
                    textAlign: "right",
                  }}
                  value={pointSetting.writeLimit}
                  onChange={(e) => {
                    setPointSetting({
                      ...pointSetting,
                      writeLimit: e.target.value,
                    });
                  }}
                />
                <PointItemContentText>회 한도</PointItemContentText>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  marginLeft: 40,
                }}
              >
                <PointItemContentText>하루 최대 지급 한도</PointItemContentText>
                <MainInput
                  type={"text"}
                  placeholder={"0"}
                  style={{
                    width: "93px",
                    textAlign: "right",
                  }}
                  value={pointSetting.writePoint * pointSetting.writeLimit}
                  disabled={true}
                  onChange={() => {}}
                />
                <PointItemContentText>포인트</PointItemContentText>
              </div>
            </PointItemWrapper>

            {/* 게시글 좋아요 받는 수마다 */}
            <PointItemWrapper>
              <PointItemTitle
                style={{
                  width: 80,
                  marginTop: 0,
                  marginRight: 42,
                }}
              >
                게시글 좋아요 받는 수마다
              </PointItemTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <MainInput
                      type={"text"}
                      placeholder={"0"}
                      style={{
                        width: "93px",
                        textAlign: "right",
                      }}
                      value={pointSetting.likePoint}
                      onChange={(e) => {
                        setPointSetting({
                          ...pointSetting,
                          likePoint: e.target.value,
                        });
                      }}
                    />
                    <PointItemContentText>포인트</PointItemContentText>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      marginLeft: 40,
                    }}
                  >
                    <PointItemContentText>1일</PointItemContentText>
                    <MainInput
                      type={"text"}
                      placeholder={"0"}
                      style={{
                        width: "93px",
                        textAlign: "right",
                      }}
                      value={pointSetting.likeLimit}
                      disabled={likeIsUnlimited}
                      onChange={(e) => {
                        setPointSetting({
                          ...pointSetting,
                          likeLimit: e.target.value,
                        });
                      }}
                    />
                    <PointItemContentText>회 한도</PointItemContentText>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      marginLeft: 40,
                    }}
                  >
                    <PointItemContentText>
                      하루 최대 지급 한도
                    </PointItemContentText>
                    <MainInput
                      type={"text"}
                      placeholder={"0"}
                      style={{
                        width: "93px",
                        textAlign: "right",
                      }}
                      value={pointSetting.likePoint * pointSetting.likeLimit}
                      disabled={true}
                      onChange={() => {}}
                    />
                    <PointItemContentText>포인트</PointItemContentText>
                  </div>
                </div>
                {/* <CheckboxWrapper
                  onClick={() => {
                    setLikeIsUnlimited(!likeIsUnlimited);
                  }}
                >
                  <Checkbox checked={likeIsUnlimited} onChange={() => {}} />
                  <CheckboxText>1일 한도 없음</CheckboxText>
                </CheckboxWrapper> */}
              </div>
            </PointItemWrapper>

            {/* 후기 1회 작성 */}
            <PointItemWrapper>
              <PointItemTitle>후기 1회 작성</PointItemTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <MainInput
                      type={"text"}
                      placeholder={"0"}
                      style={{
                        width: "93px",
                        textAlign: "right",
                      }}
                      value={pointSetting.reviewPoint}
                      onChange={(e) => {
                        setPointSetting({
                          ...pointSetting,
                          reviewPoint: e.target.value,
                        });
                      }}
                    />
                    <PointItemContentText>포인트</PointItemContentText>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      marginLeft: 40,
                    }}
                  >
                    <PointItemContentText>1일</PointItemContentText>
                    <MainInput
                      type={"text"}
                      placeholder={"0"}
                      style={{
                        width: "93px",
                        textAlign: "right",
                      }}
                      value={pointSetting.reviewLimit}
                      disabled={reviewIsUnlimited}
                      onChange={(e) => {
                        setPointSetting({
                          ...pointSetting,
                          reviewLimit: e.target.value,
                        });
                      }}
                    />
                    <PointItemContentText>회 한도</PointItemContentText>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      marginLeft: 40,
                    }}
                  >
                    <PointItemContentText>
                      하루 최대 지급 한도
                    </PointItemContentText>
                    <MainInput
                      type={"text"}
                      placeholder={"0"}
                      style={{
                        width: "93px",
                        textAlign: "right",
                      }}
                      value={
                        pointSetting.reviewPoint * pointSetting.reviewLimit
                      }
                      disabled={true}
                      onChange={() => {}}
                    />
                    <PointItemContentText>포인트</PointItemContentText>
                  </div>
                </div>
                <PretendardText
                  style={{
                    fontWeight: 500,
                    fontSize: "13px",
                    lineHeight: "18.75px",
                    color: "rgba(181, 181, 181, 0.5)",
                  }}
                >
                  계정당 상품별로 1개 후기만 허용
                </PretendardText>
                <CheckboxWrapper
                  onClick={() => {
                    setReviewIsUnlimited(!reviewIsUnlimited);
                  }}
                >
                  <Checkbox checked={reviewIsUnlimited} onChange={() => {}} />
                  <CheckboxText>1일 한도 없음</CheckboxText>
                </CheckboxWrapper>
              </div>
            </PointItemWrapper>

            {/* 오늘의 베스트 등극 */}
            <PointItemWrapper>
              <PointItemTitle>오늘의 베스트 등극</PointItemTitle>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <MainInput
                  type={"text"}
                  placeholder={"0"}
                  style={{
                    width: "93px",
                    textAlign: "right",
                  }}
                  value={pointSetting.todayBestPoint}
                  onChange={(e) => {
                    setPointSetting({
                      ...pointSetting,
                      todayBestPoint: e.target.value,
                    });
                  }}
                />
                <PointItemContentText>포인트</PointItemContentText>
              </div>
            </PointItemWrapper>

            {/* 베스트 후기 등극 */}
            <PointItemWrapper>
              <PointItemTitle>베스트 후기 등극</PointItemTitle>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <MainInput
                  type={"text"}
                  placeholder={"0"}
                  style={{
                    width: "93px",
                    textAlign: "right",
                  }}
                  value={pointSetting.bestPoint}
                  onChange={(e) => {
                    setPointSetting({
                      ...pointSetting,
                      bestPoint: e.target.value,
                    });
                  }}
                />
                <PointItemContentText>포인트</PointItemContentText>
              </div>
            </PointItemWrapper>
          </SettingContainer>
          <SaveBtnWrapper>
            {isWriteAuthority && (
              <BasicBtn
                onClick={() => {
                  editPointSettingFunc();
                }}
              >
                저장하기
              </BasicBtn>
            )}
          </SaveBtnWrapper>

          {/* ********** 포인트 지급 이벤트 ********** */}
          <PointSubTitle>포인트 지급 이벤트</PointSubTitle>
          <SettingContainer>
            {/* 이벤트 */}
            <PointItemWrapper>
              <PointItemTitle>이벤트</PointItemTitle>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 20,
                }}
              >
                <Radio
                  id={""}
                  valueText={"진행"}
                  checked={pointEvent.activation}
                  onChange={() => {
                    setPointEvent({
                      ...pointEvent,
                      activation: true,
                    });
                  }}
                />
                <Radio
                  id={""}
                  valueText={"진행 안함"}
                  checked={!pointEvent.activation}
                  onChange={() => {
                    setPointEvent({
                      ...pointEvent,
                      activation: false,
                    });
                  }}
                />
              </div>
            </PointItemWrapper>

            {/* 판매가에서 */}
            <PointItemWrapper>
              <PointItemTitle>판매가에서</PointItemTitle>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <MainInput
                  type={"text"}
                  placeholder={"0"}
                  style={{
                    width: "93px",
                    textAlign: "right",
                  }}
                  value={pointEvent.ratio}
                  onChange={(e) => {
                    setPointEvent({
                      ...pointEvent,
                      ratio: e.target.value,
                    });
                  }}
                />
                <PointItemContentText>% 지급</PointItemContentText>
              </div>
            </PointItemWrapper>

            {/* 포인트 지급 범위 */}
            <PointItemWrapper>
              <PointItemTitle>포인트 지급 범위</PointItemTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <SelectBoxV2
                    placeholder="지급 범위를 선택해주세요"
                    selectedValue={selectedRange}
                    isOpen={rangeListBoxOpen}
                    wrapperHandler={() => {
                      setRangeListBoxOpen(!rangeListBoxOpen);
                    }}
                    itemList={rangeList}
                    selectedValueSetterFunc={(value) => {
                      setSelectedRange(value);
                    }}
                  />

                  {selectedRange === "CATEGORY" && (
                    <SelectBoxV2
                      placeholder="지급 범위를 선택해주세요"
                      selectedValue={selectedCategory}
                      isOpen={categoryListBoxOpen}
                      wrapperHandler={() => {
                        setCategoryListBoxOpen(!categoryListBoxOpen);
                      }}
                      itemList={categoryList}
                      selectedValueSetterFunc={(value) => {
                        setSelectedCategory(value);
                      }}
                    />
                  )}
                </div>

                {selectedRange === "MERCH" && (
                  <>
                    <GrayBtn onClick={() => setPopupOpen(true)}>
                      포인트 지급 상품 선택
                    </GrayBtn>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {merchIdList.map((mItem, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: 10,
                              padding: "15px 0px",
                              borderBottom:
                                "0.5px solid rgba(255, 255, 255, 0.12)",
                            }}
                          >
                            <PretendardText
                              className="truncate"
                              style={{
                                width: 500,
                                fontSize: "14px",
                                fontWeight: "400",
                                lineHeight: "22px",
                                color: "#aaa",
                              }}
                            >
                              {mItem.title}
                            </PretendardText>
                            <RedBtn
                              style={{
                                backgroundColor: "#313233",
                                minWidth: 60,
                              }}
                              onClick={() => {
                                const temp = merchIdList.filter(
                                  (mItemF) => mItemF.id !== mItem.id
                                );
                                setMerchIdList(temp);
                              }}
                            >
                              삭제
                            </RedBtn>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
              </div>
            </PointItemWrapper>

            {/* 지급기간 */}
            <PointItemWrapper>
              <PointItemTitle>지급기간</PointItemTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <DateInput
                    value={moment(pointEvent.startDate).format("YYYY-MM-DD")}
                    onChange={(e) => {
                      setPointEvent({
                        ...pointEvent,
                        startDate: e.target.value,
                      });
                    }}
                  />
                  <span
                    style={{
                      width: 6,
                      height: 1,
                      backgroundColor: "rgba(181, 181, 181, 0.5)",
                    }}
                  />
                  <DateInput
                    value={moment(pointEvent.endDate).format("YYYY-MM-DD")}
                    onChange={(e) => {
                      setPointEvent({ ...pointEvent, endDate: e.target.value });
                    }}
                  />
                </div>
                <CheckboxWrapper
                  onClick={() => {
                    setNoPeriodLimit(!noPeriodLimit);
                  }}
                >
                  <Checkbox
                    style={{
                      backgroundColor: "transparent",
                    }}
                    checked={noPeriodLimit}
                    onChange={() => {
                      setNoPeriodLimit(!noPeriodLimit);
                    }}
                  />
                  <CheckboxText
                    style={{
                      fontSize: "15px",
                      fontWeight: "500",
                      lineHeight: "21.5px",
                      color: "#aaa",
                    }}
                  >
                    기간 제한 없음
                  </CheckboxText>
                </CheckboxWrapper>
              </div>
            </PointItemWrapper>
          </SettingContainer>
          <SaveBtnWrapper>
            {isWriteAuthority && (
              <BasicBtn
                onClick={() => {
                  editPointEventFunc();
                }}
              >
                저장하기
              </BasicBtn>
            )}
          </SaveBtnWrapper>

          {/* ********** 포인트 지급 내역 ********** */}
          <PointSubTitle
            style={{
              marginBottom: 20,
            }}
          >
            포인트 지급 내역
          </PointSubTitle>
          <TableTop>
            <TableCount
              text={"포인트 지급 내역"}
              count={pagination.totalCount}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"이름, 아이디(이메일), 닉네임, 사유"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    sessionStorageInit();
                    navigate(
                      `${route.operation_point}?page=1&keyword=${keyword}`
                    );
                  }
                }}
                onClick={() => {
                  sessionStorageInit();
                  navigate(
                    `${route.operation_point}?page=1&keyword=${keyword}`
                  );
                }}
              />
              {/* <ExcelBtn /> */}
            </div>
          </TableTop>

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="61px" />
              {/* 이름/아이디(이메일) */}
              <col width="213px" />
              {/* 닉네임 */}
              <col width="96px" />
              {/* 증감 */}
              <col width="143px" />
              {/* 지급일 */}
              <col width="136px" />
              {/* 사유 */}
              <col width="257px" />
              {/* 지급자 */}
              <col width="138px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // 배열 병합 및 중복 제거
                        const mergedArray = [
                          ...pointList,
                          ...checkedListStorage,
                        ].reduce((acc, current) => {
                          const existingItem = acc.find(
                            (item) => item.id === current.id
                          );
                          if (!existingItem) {
                            acc.push(current);
                          }
                          return acc;
                        }, []);

                        setCheckedListStorage(mergedArray);
                      } else {
                        const idsToExclude = new Set(
                          pointList.map((item) => item.id)
                        );
                        const filteredArray = checkedListStorage.filter(
                          (item) => !idsToExclude.has(item.id)
                        );

                        setCheckedListStorage(filteredArray);
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    이름/아이디(이메일)
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    닉네임
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    증감
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    지급일
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    사유
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    지급자
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {pointList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "66px",
                      padding: "20px 0px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={checkedListStorage.some(
                          (item02) => item02.id === item.id
                        )}
                        onChange={() => {
                          if (
                            checkedListStorage.length > 0 &&
                            checkedListStorage.some(
                              (item02) => item02.id === item.id
                            )
                          ) {
                            let temp = checkedListStorage.filter(
                              (item02) => item02.id !== item.id
                            );
                            setCheckedListStorage(temp);
                          } else {
                            setCheckedListStorage([
                              item,
                              ...checkedListStorage,
                            ]);
                          }
                        }}
                      />
                    </Td>
                    {/* 이름/아이디(이메일) */}
                    <Td>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <TableText
                          style={{
                            maxWidth: 166,
                          }}
                        >
                          {item.member.name}
                        </TableText>
                        <TableText
                          style={{
                            maxWidth: 166,
                          }}
                        >
                          {item.member.email}
                        </TableText>
                      </div>
                    </Td>
                    {/* 닉네임 */}
                    <Td>
                      <TableText
                        style={{
                          maxWidth: 62,
                        }}
                      >
                        {item.member.nickname}
                      </TableText>
                    </Td>
                    {/* 증감 */}
                    <Td>
                      <TableText
                        style={{
                          maxWidth: 72,
                          color: item.isPlus ? "#009bde" : "#cf6679",
                        }}
                      >
                        {item.isPlus ? "+" : "-"}
                        {Number(item.amount).toLocaleString()}
                      </TableText>
                    </Td>
                    {/* 지급일 */}
                    <Td>
                      <TableText>
                        {moment(item.createdAt).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                    {/* 사유 */}
                    <Td>
                      <TableText
                        style={{
                          maxWidth: 247,
                        }}
                      >
                        {item.reason}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          maxWidth: 80,
                        }}
                      >
                        {item.adminName}
                      </TableText>
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>

          {pointList.length > 0 ? null : <Empty />}

          {/* 페이지네이션 영역 */}
          <Pagination
            route={route.operation_point}
            queryString={`keyword=${keyword}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>

      {/* 지정 상품 추가 팝업 */}
      {popupOpen && (
        <RelatedProductsPopup
          setPopupOpen={setPopupOpen}
          setValue={setMerchIdList}
          value={merchIdList}
        />
      )}
    </>
  );
};

export default OperationPoint;

const PointSubTitle = styled(PretendardText).attrs((props) => {})`
  font-weight: 600;
  font-size: 18px;
  line-height: 32.5px;
  letter-spacing: -0.3%;
  color: #f3f3f3;
`;

const SettingContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

const PointItemWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  border-bottom: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
  padding: 21px 0px;
`;

const PointItemTitle = styled(PretendardText).attrs((props) => {})`
  width: 122px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
  margin-top: 12px;
`;

const PointItemContentText = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 15px;
  line-height: 22.75px;
  color: #aaa;
`;

const SaveBtnWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 79px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 70px;
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;
`;
